import { Stack } from "@material-ui/core";
import Label from "components/Label";
import {
  crmStatusLabels,
  getContactCrmStatus,
  getContactCrmIsHot,
  getContactCrmSubStatus,
  findCrmSubStatusDefinition
} from "../../../../../@types/sharedSchema";
import { CrmStatusIcon, CrmHotFireIcon } from "../../crm/CrmIcons";
import type { RealEstateContact, CrmStatus } from "../../../../../@types/sharedSchema";
import type { LabelColor } from "components/Label";

const statusChipColor: Record<CrmStatus, LabelColor> = {
  new: "info",
  in_progress: "primary",
  paused: "warning",
  won: "success",
  lost: "default",
  irrelevant: "default"
};

// CRM lead status chip (A1 v2). One compact chip for the lifecycle status — "בטיפול · במו״מ" when a
// sub-status is set — plus a flame beside it when the contact is a hot lead.
//
// A contact with neither renders NOTHING. There used to be a fallback here to a legacy
// `customerSeriousness` chip for un-migrated contacts; it is gone with the rest of that
// vocabulary — showing a realtor "רציני" in a product whose only statuses are
// חדש/בטיפול/מושהה/נחתמה עסקה/אבוד/לא רלוונטי is worse than showing nothing.
export function ContactCrmStatusChip({ contact }: { contact: RealEstateContact }): JSX.Element | null {
  const status = getContactCrmStatus(contact);
  const isHot = getContactCrmIsHot(contact);
  const sub = status === "in_progress" ? findCrmSubStatusDefinition(getContactCrmSubStatus(contact) ?? "") : undefined;

  if (!status && !isHot) return null;

  return (
    <Stack direction="row" alignItems="center" flexWrap="wrap" gap={0.5} component="span">
      {status && (
        <Label variant="ghost" color={statusChipColor[status]}>
          <Stack direction="row" alignItems="center" spacing={0.5} component="span">
            <CrmStatusIcon iconKey={sub?.icon ?? status} sx={{ fontSize: 14 }} />
            <span>{sub ? `${crmStatusLabels.in_progress} · ${sub.label}` : crmStatusLabels[status]}</span>
          </Stack>
        </Label>
      )}
      {isHot && <CrmHotFireIcon isHot sx={{ fontSize: 18 }} />}
    </Stack>
  );
}
